import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutContext } from '../../../../layout-context.model';
import { AppRoutes } from '@app/core/routing';
import { PLATFORM_LOGO_SRC } from '@app/core/site-context';
import { IconComponent } from '@app/ui';

@Component({
  selector: 'gb-footer-simple',
  standalone: true,
  imports: [RouterModule, IconComponent],
  templateUrl: './footer-simple.component.html',
  styleUrls: ['./footer-simple.component.scss'],
})
export class FooterSimpleComponent {
  protected readonly AppRoutes = AppRoutes;
  protected readonly PLATFORM_LOGO_SRC = PLATFORM_LOGO_SRC;
  protected readonly fundraisePath = AppRoutes.create.fundraiser();

  @Input({ required: true }) ctx!: LayoutContext;

  readonly year = new Date().getFullYear();

  // Legal and support pages live on the Givebrite site, never on the charity's own host.
  protected readonly givebriteTerms = `${AppRoutes.external.givebriteHome()}${AppRoutes.page.terms()}`;
  protected readonly givebritePrivacy = `${AppRoutes.external.givebriteHome()}${AppRoutes.page.privacy()}`;
  protected readonly givebriteSupport = `${AppRoutes.external.givebriteHome()}${AppRoutes.page.support()}`;

  protected get brandName(): string {
    return this.ctx.charity?.name ?? 'Givebrite';
  }
}
